import React, { useEffect } from 'react'
import style from './hubspot-form.mod.scss'

const HubspotForm = ({
  region = 'na1',
  portalId = '45479371',
  formId = 'ed17f4c1-fd34-4577-82f0-59a7b7cf1c08'
}) => {
  useEffect(() => {
    if (window.hbspt) {
      window.hbspt.forms.create({
        region,
        portalId,
        formId,
        target: `#hubspot-form-${formId}`
      })
    }
  }, [region, portalId, formId])

  return <div className={style.hubspot} id={`hubspot-form-${formId}`} />
}

export default HubspotForm
